export default __webpack_public_path__ + "static/media/DashedBorder.9c868448.svg";